import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

export default function MultiSelectSearchDropdown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  showSelectAll,
  disabled,
  singleSelect = false, // defaults to false
  onSearchInputChange, // Parent function to trigger API call
}) {
  const [isActive, setIsActive] = useState(false);
  const [searchKey, setSearchKey] = useState(""); // Search input state
  const [filteredOptions, setFilteredOptions] = useState(options); // Filtered options
  const dropdownRef = useRef(null);

  // Update filtered options whenever options change
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  // Close dropdown on clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Update filtered options based on searchKey
  useEffect(() => {
    if (searchKey === "") {
      setFilteredOptions(options);
    } else {
      setFilteredOptions(
        options.filter((option) =>
          option.label.toLowerCase().includes(searchKey.toLowerCase())
        )
      );
    }
  }, [searchKey, options]);

  // When auto-selection changes, clear searchKey so displayValue comes from selected options
  useEffect(() => {
    if (selected && selected.length > 0) {
      setSearchKey("");
    }
  }, [selected]);

  const handleSelect = (option) => {
    if (singleSelect) {
      setSelected(option.id);
      setSearchKey("");
      setIsActive(false);
    } else {
      const isSelected = selected.includes(option.id);
      if (isSelected) {
        setSelected(selected.filter((id) => id !== option.id));
      } else {
        setSelected([...selected, option.id]);
      }
    }
  };

  const handleSelectAll = () => {
    if (singleSelect) return;
    if (selected.length === options.length) {
      setSelected([]);
    } else {
      setSelected(options.map((option) => option.id));
    }
  };

  // Clear current selection and searchKey
  const clearValue = () => {
    if (singleSelect) {
      setSelected("");
    } else {
      setSelected([]);
    }
    setSearchKey("");
  };

  // Compute display value: when there is a selection, show the joined labels; otherwise show searchKey.
  const displayValue = singleSelect
    ? options.find((opt) => opt.id === selected)?.label || searchKey
    : selected.length > 0
    ? options
        .filter((opt) => selected.includes(opt.id))
        .map((opt) => opt.label)
        .join(", ")
    : searchKey;

  const handleChange = (e) => {
    const newKey = e.target.value;
    setSearchKey(newKey);
    if (onSearchInputChange) {
      onSearchInputChange(newKey);
    }
  };

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>

      <div className="dropdown-btn" onClick={() => setIsActive(true)}>
        <input
          type="text"
          className="dropdown-input"
          style={{ color: "#6A6A6A" }}
          placeholder={placeholder}
          value={displayValue}
          onChange={handleChange}
          onFocus={() => setIsActive(true)}
        />
        {displayValue && (
          <span
            style={{
              cursor: "pointer",
              color: "#aaa",
              marginRight: "30px",
              fontSize: "16px",
              userSelect: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              clearValue();
            }}
          >
            ×
          </span>
        )}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>

      {isActive && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: "200px",
            overflowY: "scroll",
          }}
        >
          {showSelectAll && !singleSelect && options.length > 0 && (
            <div
              className="dropdown-item"
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <input
                type="checkbox"
                className="delete-question-checkbox-dqc"
                checked={
                  selected.length > 0 && selected.length === options.length
                }
                onChange={handleSelectAll}
              />
              <label onClick={handleSelectAll}>Select All</label>
            </div>
          )}

          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div
                key={option.id}
                className="dropdown-item"
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <input
                  type="checkbox"
                  className="delete-question-checkbox-dqc"
                  checked={
                    singleSelect
                      ? selected === option.id
                      : selected.includes(option.id)
                  }
                  onChange={() => handleSelect(option)}
                />
                <label onClick={() => handleSelect(option)}>
                  {option.label}
                </label>
              </div>
            ))
          ) : (
            <div className="dropdown-no-results">No results found</div>
          )}
        </div>
      )}
    </div>
  );
}
